export default "__VITE_ASSET__18a356bc__"